var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRetweetssmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.21 6.11a.38.38 0 0 1-.37-.38V4.07c0-.62-.51-1.12-1.13-1.12H1.79a.38.38 0 0 1-.37-.38c0-.2.17-.37.37-.37h6.92c1.04 0 1.88.84 1.88 1.87v1.66c0 .21-.17.38-.38.38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.37 4.53a.37.37 0 0 1-.26-.1L1.53 2.83a.37.37 0 0 1 0-.53L3.1.73a.38.38 0 0 1 .53 0c.14.15.14.39 0 .53L2.32 2.58l1.32 1.31c.14.15.14.39 0 .53a.4.4 0 0 1-.27.11ZM10.21 9.8H3.29a1.88 1.88 0 0 1-1.87-1.88V6.26c0-.2.17-.37.37-.37.2 0 .38.17.38.37v1.66c0 .62.5 1.13 1.12 1.13h6.92c.2 0 .38.17.38.37 0 .2-.17.38-.38.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63 11.38a.37.37 0 0 1-.26-.11.38.38 0 0 1 0-.54l1.31-1.31-1.31-1.31a.38.38 0 0 1 0-.53.38.38 0 0 1 .53 0l1.58 1.58a.37.37 0 0 1 0 .53L8.9 11.27a.35.35 0 0 1-.27.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweetssmall);
export default __webpack_public_path__ + "static/media/retweets.small.3ee6695115c1de404822fc8ee4a170c1.svg";
export { ForwardRef as ReactComponent };